import React from "react";
import MaintenanceTypeMasterManagement from "../MaintenanceTypeMasterManagement";
import MaintenancePriorityMasterManagement from "../MaintenancePriorityMasterManagement";

export default function MaintenanceMastersSection({ onMastersChange, onNotify }) {
  return (
    <div
      id="md-masters"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Master table management</h3>
        <p className="user-builder-panel__hint">
          Configure maintenance types and priority levels used in request forms and the directory.
        </p>
      </div>
      <div style={{ marginTop: "1.5rem" }}>
        <MaintenanceTypeMasterManagement onNotify={onNotify} onMastersChange={onMastersChange} />
      </div>
      <div style={{ marginTop: "2.5rem" }}>
        <MaintenancePriorityMasterManagement
          onNotify={onNotify}
          onMastersChange={onMastersChange}
        />
      </div>
    </div>
  );
}
